import { BUILDER_EDIT_MODES, ROUTES } from '@/constants'

import { GENERATOR_SEARCH_PARAM, QR_TYPE } from '../generatorTypes'

const QR_TYPE_TO_CONTENT_FORM_PAGE_URL: Record<QR_TYPE, string> = {
	[QR_TYPE.App]: ROUTES.generator.app,
	[QR_TYPE.VCard]: ROUTES.generator.vCard,
	[QR_TYPE.Images]: ROUTES.generator.images,
	[QR_TYPE.PlainText]: ROUTES.generator.plainText,
	[QR_TYPE.Wifi]: ROUTES.generator.wifi,
	[QR_TYPE.Url]: ROUTES.generator.url,
	[QR_TYPE.Video]: ROUTES.generator.video,
	[QR_TYPE.Facebook]: ROUTES.generator.facebook,
	[QR_TYPE.BusinessPage]: ROUTES.generator.businessPage,
	[QR_TYPE.SocialMedia]: ROUTES.generator.socialMedia,
	[QR_TYPE.Menu]: ROUTES.generator.menu,
	[QR_TYPE.Pdf]: ROUTES.generator.pdf,
}

export const buildEditModeContentFormPageUrl = ({
	qrType,
	targetId,
	tempQrId,
	isChangeTypeMode,
}: {
	qrType: QR_TYPE
	targetId: string
	tempQrId: string
	isChangeTypeMode: boolean
}) =>
	`${QR_TYPE_TO_CONTENT_FORM_PAGE_URL[qrType]}?${GENERATOR_SEARCH_PARAM.Target}=${targetId}&edit=${isChangeTypeMode ? BUILDER_EDIT_MODES.TYPE : BUILDER_EDIT_MODES.CONTENT}&${GENERATOR_SEARCH_PARAM.Id}=${tempQrId}`
